/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleBigQueryGa4RevenueCurrencyData } from './GoogleBigQueryGa4RevenueCurrencyData';
import {
    GoogleBigQueryGa4RevenueCurrencyDataFromJSON,
    GoogleBigQueryGa4RevenueCurrencyDataFromJSONTyped,
    GoogleBigQueryGa4RevenueCurrencyDataToJSON,
    GoogleBigQueryGa4RevenueCurrencyDataToJSONTyped,
} from './GoogleBigQueryGa4RevenueCurrencyData';

/**
 * 
 * @export
 * @interface GoogleBigQueryGa4DailyReportRowData
 */
export interface GoogleBigQueryGa4DailyReportRowData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    events?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    sessions?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchases?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    transactions?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchaseRevenue?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchaseRevenueMissingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    canonicalPurchaseRevenue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchaseRevenueCurrency?: string | null;
    /**
     * 
     * @type {GoogleBigQueryGa4DailyReportRowDataPurchaseRevenueAvailabilityEnum}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchaseRevenueAvailability?: GoogleBigQueryGa4DailyReportRowDataPurchaseRevenueAvailabilityEnum;
    /**
     * 
     * @type {Array<GoogleBigQueryGa4RevenueCurrencyData>}
     * @memberof GoogleBigQueryGa4DailyReportRowData
     */
    purchaseRevenueByCurrency?: Array<GoogleBigQueryGa4RevenueCurrencyData>;
}


/**
 * @export
 */
export const GoogleBigQueryGa4DailyReportRowDataPurchaseRevenueAvailabilityEnum = {
    Available: 'AVAILABLE',
    MixedCurrency: 'MIXED_CURRENCY',
    UnknownCurrency: 'UNKNOWN_CURRENCY',
    Unavailable: 'UNAVAILABLE'
} as const;
export type GoogleBigQueryGa4DailyReportRowDataPurchaseRevenueAvailabilityEnum = typeof GoogleBigQueryGa4DailyReportRowDataPurchaseRevenueAvailabilityEnum[keyof typeof GoogleBigQueryGa4DailyReportRowDataPurchaseRevenueAvailabilityEnum];


/**
 * Check if a given object implements the GoogleBigQueryGa4DailyReportRowData interface.
 */
export function instanceOfGoogleBigQueryGa4DailyReportRowData(value: object): value is GoogleBigQueryGa4DailyReportRowData {
    return true;
}

export function GoogleBigQueryGa4DailyReportRowDataFromJSON(json: any): GoogleBigQueryGa4DailyReportRowData {
    return GoogleBigQueryGa4DailyReportRowDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4DailyReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4DailyReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'events': json['events'] == null ? undefined : json['events'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'purchases': json['purchases'] == null ? undefined : json['purchases'],
        'transactions': json['transactions'] == null ? undefined : json['transactions'],
        'purchaseRevenue': json['purchaseRevenue'] == null ? undefined : json['purchaseRevenue'],
        'purchaseRevenueMissingCount': json['purchaseRevenueMissingCount'] == null ? undefined : json['purchaseRevenueMissingCount'],
        'canonicalPurchaseRevenue': json['canonicalPurchaseRevenue'] === undefined ? undefined : json['canonicalPurchaseRevenue'] === null ? null : json['canonicalPurchaseRevenue'],
        'purchaseRevenueCurrency': json['purchaseRevenueCurrency'] === undefined ? undefined : json['purchaseRevenueCurrency'] === null ? null : json['purchaseRevenueCurrency'],
        'purchaseRevenueAvailability': json['purchaseRevenueAvailability'] == null ? undefined : json['purchaseRevenueAvailability'],
        'purchaseRevenueByCurrency': json['purchaseRevenueByCurrency'] == null ? undefined : ((json['purchaseRevenueByCurrency'] as Array<any>).map(GoogleBigQueryGa4RevenueCurrencyDataFromJSON)),
    };
}

export function GoogleBigQueryGa4DailyReportRowDataToJSON(json: any): GoogleBigQueryGa4DailyReportRowData {
    return GoogleBigQueryGa4DailyReportRowDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4DailyReportRowDataToJSONTyped(value?: GoogleBigQueryGa4DailyReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'events': value['events'],
        'sessions': value['sessions'],
        'purchases': value['purchases'],
        'transactions': value['transactions'],
        'purchaseRevenue': value['purchaseRevenue'],
        'purchaseRevenueMissingCount': value['purchaseRevenueMissingCount'],
        'canonicalPurchaseRevenue': value['canonicalPurchaseRevenue'],
        'purchaseRevenueCurrency': value['purchaseRevenueCurrency'],
        'purchaseRevenueAvailability': value['purchaseRevenueAvailability'],
        'purchaseRevenueByCurrency': value['purchaseRevenueByCurrency'] == null ? undefined : ((value['purchaseRevenueByCurrency'] as Array<any>).map(GoogleBigQueryGa4RevenueCurrencyDataToJSON)),
    };
}

